import React from 'react'

import { Icon, Discount, Quality } from '@cgtrader/triangle-ui/dist/src/ssr-index'

export const getPricingCheckboxFiltersConfig = (translate) => [{
  label: '',
  filters: [
    {
      value: 'on_sale',
      label: (
        <span className="filter-wrapper__option--with-icon">
          <Icon notSpaced svgComponent={Discount} color="primary" size="small" />
          <span>{translate('search_page.filters.price.on_sale')}</span>
        </span>
      ),
    },
    {
      value: 'with_subscription',
      label: (
        <span className="filter-wrapper__option--with-icon">
          <Icon notSpaced svgComponent={Quality} color="primary" size="small" />
          <span>{translate('search_page.filters.price.with_subscription')}</span>
        </span>
      ),
    },
  ],
}]
